import { render, staticRenderFns } from "./ViewItemTypeGroup.vue?vue&type=template&id=b5cf5724"
import script from "./ViewItemTypeGroup.vue?vue&type=script&lang=js"
export * from "./ViewItemTypeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports